import React from 'react';
import { Box, Container, IconButton, Typography } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        // mt: 'auto', // Removed margin to sit flush
        background: 'none',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)',
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 1 }}>
          <IconButton
            href="https://github.com/castvier"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ 
              color: 'text.secondary',
              transition: 'all 0.2s',
              '&:hover': {
                color: 'primary.main',
                transform: 'translateY(-2px)'
              }
            }}
            aria-label="GitHub Profile"
          >
            <GitHubIcon />
          </IconButton>
          <IconButton
            href="https://www.linkedin.com/in/jimwell-c-9551ba143"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ 
              color: 'text.secondary',
              transition: 'all 0.2s',
              '&:hover': {
                color: 'primary.main',
                transform: 'translateY(-2px)'
              }
            }}
            aria-label="LinkedIn Profile"
          >
            <LinkedInIcon />
          </IconButton>
        </Box>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ opacity: 0.7 }}>
          {new Date().getFullYear()} Jimwell Castillo
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;